// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__whtph","row":"styles_row__1iPph"};